require('jquery-validation');

let rules = {
    'civilite': {
        required: true
    },
    'perso_email': {
        required: true,
        verifEmail: true
    },
    'modeles': {
        required: true
    },
    'perso_nom': {
        required: true,
        verifName: true
    },
    'perso_prenom': {
        required: true,
        verifName: true
    },
    'perso_telephone': {
        required: true,
        verifTel: true
    },
    'ville': {
        required: true,
        verifVille: true
    }
};

if (window.hasOwnProperty('Bloom')) {
    window.Bloom.rules = rules;
} else {
    window.Bloom = {
        rules: rules
    }
}

module.exports = {
    /**
     * Initialize the form validator
     * @param selector
     */
    initialize: function (selector = 'form:visible', myRules = rules, myMessages = {}) {
        $.validator.addMethod("verifName", function (e, t) {
            return this.optional(t) || /^[a-zA-Z-àá\sâäòóôöèéêëçìíîïùúûüÿ\s\-]+$/.test(e)
        }, "Seuls les caractères alphabétiques sont autorisés.");

        $.validator.addMethod("verifTel", function (e, t) {
            return this.optional(t) || /^((\+|00)\d{2}|0)(\d{9}$)/.test(e);
        }, "Erreur de format téléphone.");

        $.validator.addMethod("verifText", function (value, element) {
            return this.optional(element) || /^([a-zA-Z-àá\sâäòóôöèéêëçìíîïùúûüÿ'])+$/.test(value);
        }, "Seuls les caractères alphabétiques sont autorisés.");

        $.validator.addMethod("verifVille", function (value, element) {
            return this.optional(element) || /^([0-9a-zA-Z-àá\sâäòóôöèéêëçìíîïùúûüÿ'])+$/.test(value);
        }, "Seuls les caractères alphabétiques sont autorisés.");

        $.validator.addMethod("verifEmail", function(value, element) {
            return this.optional(element) || /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/i.test(value);
        }, "Format XXX@XXX.XXX attendu.");

        $.validator.addMethod("verifCP", function (value, element) {
            return this.optional(element) || /^\d{5}$/.test(value);
        }, "<span class=\"table-cell\">Format XXXXX attendu.</span>");

        $.validator.addMethod("verifTextAlphaNum", function (value, element) {
            return this.optional(element) || /^([a-zA-Z0-9-àá\sâäòóôöèéêëçìíîïùúûüÿ'])+$/.test(value);
        }, "<span class=\"table-cell\">Seuls les caractères alphanumériques sont autorisés.</span>");

        $.validator.addMethod("verifYear", function (value, element) {
            return this.optional(element) || /^\d{4}$/.test(value);
        }, "<span class=\"table-cell\">Format XXXX attendu.</span>");

        $.validator.messages.required           = 'Ce champ est requis.';
        $.validator.messages.number             = 'Merci d\'entrer un chiffre valide.';
        $.validator.messages.email              = 'Format XXX@XXX.XXX attendu.';
        $.validator.messages.require_from_group = 'L\'un de ces deux champs est requis.';
        $.validator.messages.min                = 'Merci d\'entrer une année valide';
        $.validator.messages.max                = 'Merci d\'entrer un chiffre inférieur à {0}';

        let validator = $(selector).validate({
            focusInvalid: false,
            ignore: 'fieldset:not(:visible) select, fieldset:not(:visible) input',
            errorPlacement: function(error, element) {
                if (element.is(":radio")) {
                    error.insertAfter(element.closest('.custom-radio'))
                } else if (element.is(":checkbox")) {
                    error.insertAfter(element.closest('.checkbox-group'))
                } else {
                    error.insertAfter(element.closest('.input-group'));
                }
                element.addClass('error');
                element.closest('.input-group').addClass('error');
            },
            highlight: function(element, errorClass, stack) {
                $(element).addClass('error');
                $(element).closest('.input-group').addClass('error');
            },
            unhighlight: function(element, errorClass, stack) {
                $(element).removeClass('error');
                $(element).closest('.input-group').removeClass('error');
            },
            messages: myMessages,
            rules: myRules
        });
    },
    submission: function(selector = 'form:visible') {
        let thisForm = $(selector),
        validator = thisForm.data('validator');
        thisForm.validate();
        if (validator !== undefined && validator.form() && validator.valid()) {
            // console.info('Formulaire valide');
            return true;
        } else {
            // console.warn('Formulaire invalide');
            return validator.errorList;
        }
    },
    raz: function(selector = 'form:visible') {
        let thisForm = $(selector),
        validator = thisForm.data('validator');
        thisForm.validate().resetForm();
        thisForm.find('.error').removeClass('error');
    },
    razVal: function(selector = 'form:visible') {
        // Réinitialisation formulaire
        $(selector + ' [type="radio"]').prop('checked', false);
        $(selector + ' .form-control:not(.disabled)').val('');
        $(selector + ' .message').css('display', 'none');
    }
};
